import { Alert, Stack, TextField } from "@mui/material";

/**
 * One input per prefill-linked field that would otherwise reach the client blank: either the
 * backend refused to send without it (a missing client/bank/MARA detail, `blocking: true`) or it
 * is mapped to the linked admission and no admission is picked (never blocks the send on its own,
 * so nobody would otherwise be asked). Typed values are kept per file, matching how the backend's
 * `overrides` map is keyed, and always win over whatever value the backend would have resolved.
 */
const SendOverridesSection = ({ fields, overridesByFile, onChange }) => {
  if (fields.length === 0) {
    return null;
  }

  const hasBlockingField = fields.some((field) => field.blocking);

  return (
    <Stack spacing={1.5}>
      <Alert severity={hasBlockingField ? "error" : "info"}>
        {hasBlockingField
          ? "Type the missing values below, sending will keep failing until they are filled in."
          : "These fields will otherwise reach the client blank. Type a value to send instead, or leave them blank if that is intentional."}
      </Alert>
      {fields.map((field) => (
        <TextField
          key={`${field.fileId}:${field.fieldName}`}
          fullWidth
          size="small"
          label={field.fileName ? `${field.label} (${field.fileName})` : field.label}
          required={field.blocking}
          value={overridesByFile[field.fileId]?.[field.fieldName] || ""}
          onChange={(event) => onChange(field.fileId, field.fieldName, event.target.value)}
        />
      ))}
    </Stack>
  );
};

export default SendOverridesSection;
